import type { Experience } from '../types/experience'

export const experiences: Experience[] = [
  {
    id: 'chinet-lead-mobile-dev',
    title: 'Lead Mobile App Developer',
    company: 'ChiNet Link Tech',
    duration: '06/2026 – Present',
    location: 'Addis Ababa, Ethiopia (Onsite)',
    description: [
      'Serving as Lead Mobile App Developer at ChiNet Link Tech (sister company of RaAz Transport SC).',
      'Leading Flutter mobile application engineering for RaAz\'s Transport Management System (TMS) project.',
      'Architecting and developing a shipment marketplace mobile platform where shippers post freight gigs and carriers submit competitive real-time bids.',
      'Leveraging Flutter with GetX state management for predictable, responsive mobile UI and performant cross-platform architecture.'
    ],
    technologies: ['Flutter', 'Dart', 'GetX State Management', 'TMS / ERP', 'Shipment Marketplace', 'Android', 'iOS'],
    type: 'work',
    isOngoing: true,
    startDate: '2026-06'
  },
  {
    id: 'raaz-mobile-dev',
    title: 'Mobile app developer',
    company: 'RaAz Transport SC',
    duration: '10/2025 – Present',
    location: 'Remote',
    description: [
      'Developed a comprehensive transport management system ERP within a mobile app using Expo bare workflow.',
      'Implemented advanced background location tracking for GPS-less trucks.',
      'Built integrated notification system and offline-first design for improved accessibility.',
      'Designed multi-role interface adapting to diverse user needs with permission-based segmentation of screens and UI elements.'
    ],
    technologies: ['Expo (Bare Workflow)', 'React Native', 'TypeScript', 'Background Location Tracking', 'Notifications', 'Offline-First'],
    type: 'work',
    isOngoing: true,
    startDate: '2025-10'
  },
  {
    id: 'hidyat-mobile-dev',
    title: 'Mobile App Developer',
    company: 'Hidyat General Trading PLC',
    duration: '10/2025 – 02/2026',
    location: 'Mekelle',
    description: [
      'Developed cross-platform mobile applications using Flutter for a ride-hailing and vehicle rental platform.',
      'Implemented rider, driver, and vehicle rental workflows, including real-time trip tracking, ride scheduling, rental booking, authentication, notifications, and payment-related features.',
      'Collaborated with backend and product teams to integrate REST APIs, location services, and real-time communication systems while ensuring responsive UI/UX across Android and iOS platforms.',
      'Contributed to application architecture, feature implementation, testing, debugging, and performance optimization throughout the development lifecycle.'
    ],
    technologies: ['Flutter', 'Dart', 'REST APIs', 'Location Services', 'Real-Time Communication', 'Android', 'iOS'],
    type: 'work',
    isOngoing: false,
    startDate: '2025-10',
    endDate: '2026-02'
  },
  {
    id: 'neo-co-founder',
    title: 'Co-founder & Lead Software Engineer',
    company: 'Neo Technologies (NeoTech PLC)',
    duration: '07/2023 – Present',
    location: "Mek'elē",
    description: [
      'Founded and lead Neo Technologies, delivering full-stack systems for healthcare, hospitality, and logistics sectors.',
      'Architected and developed large-scale web applications using NestJS, Vue 3, and MongoDB.',
      'Managed deployments via GitHub Actions, Docker, and Nginx on VPS environments.',
      'Mentored junior developers and set up coding standards, version control workflows, and CI/CD practices.',
      'Oversaw product roadmaps, client relations, and cross-functional team coordination.'
    ],
    technologies: ['NestJS', 'Vue 3', 'MongoDB', 'TypeScript', 'GitHub Actions', 'Docker', 'Nginx', 'VPS (Ubuntu)'],
    type: 'work',
    isOngoing: true,
    startDate: '2023-07'
  },
  {
    id: 'raaz-backend-engineer',
    title: 'Backend Engineer',
    company: 'RaAz Transport SC',
    duration: '09/2024 – 11/2024',
    location: 'Mekelle, Ethiopia',
    description: [
      'Developed and implemented a transport management system (TMS) as a backend developer, streamlining management of fleet, freight orders, operations, and HR in an ERP-style platform.',
      'Designed and optimized database schemas to ensure the scalability and efficiency of the transport management system.',
      'Implemented security protocols to protect sensitive data, achieving compliance with industry standards using a combination of RBAC and PBAC.'
    ],
    technologies: ['Node.js', 'REST APIs', 'Database Schema Optimization', 'RBAC & PBAC Security', 'TMS / ERP'],
    type: 'work',
    isOngoing: false,
    startDate: '2024-09',
    endDate: '2024-11'
  },
  {
    id: 'tilabs-mobile-dev',
    title: 'Mobile App Developer',
    company: 'TiLabs Systems',
    duration: '12/2022 – 05/2023',
    location: "Mek'elē",
    description: [
      'Built and optimized cross-platform mobile applications using Flutter.',
      'Worked closely with UI/UX designers to deliver smooth and intuitive app experiences.',
      'Assisted in backend integration and QA testing to ensure stability and performance.',
      'Contributed to major corporate projects, improving app workflows and team collaboration.'
    ],
    technologies: ['Flutter', 'Dart', 'UI/UX Integration', 'QA Testing', 'REST APIs'],
    type: 'work',
    isOngoing: false,
    startDate: '2022-12',
    endDate: '2023-05'
  },
  {
    id: 'bst-fullstack-dev',
    title: 'Full-Stack Developer',
    company: 'Bureau of Science and Technology',
    duration: '10/2021 – 10/2022',
    location: "Mek'elē",
    description: [
      'Built and deployed the organization’s main web platform using PHP (Lumen) and JavaScript.',
      'Designed backend APIs and integrated internal tools for staff communication and content management.',
      'Developed a local email and video-calling system for intra-office use.',
      'Collaborated with stakeholders to turn static concepts into dynamic, maintainable web solutions.'
    ],
    technologies: ['PHP (Lumen)', 'JavaScript', 'REST APIs', 'Local Email & Video-Calling', 'MySQL'],
    type: 'work',
    isOngoing: false,
    startDate: '2021-10',
    endDate: '2022-10'
  },
  {
    id: 'mekelle-university-it',
    title: 'BSc In Information Technology',
    company: 'Mekelle University',
    duration: '11/2019 – 06/2026',
    location: "Mek'elē",
    description: [
      'Earned BSc In Information Technology degree from Mekelle University.',
      'Specialized in software engineering, backend systems, mobile development, and cloud infrastructure.'
    ],
    technologies: ['Information Technology', 'Software Engineering', 'System Architecture', 'Cloud Infrastructure'],
    type: 'education',
    isOngoing: false,
    startDate: '2019-11',
    endDate: '2026-06'
  }
]

// Timeline milestones for visual representation
export const milestones = [
  {
    year: '2019',
    title: 'BSc IT Degree at Mekelle University',
    description: 'Began BSc in Information Technology (11/2019 – 06/2026)'
  },
  {
    year: '2021',
    title: 'Full-Stack Developer at BST',
    description: 'Built web platform with PHP Lumen and intra-office communication system'
  },
  {
    year: '2022',
    title: 'Mobile App Developer at TiLabs',
    description: 'Developed cross-platform mobile apps with Flutter'
  },
  {
    year: '2023',
    title: 'Co-founder & Lead Engineer at Neo Technologies',
    description: 'Architecting full-stack systems for healthcare, hospitality, and logistics'
  },
  {
    year: '2024',
    title: 'Backend Engineer at RaAz Transport SC',
    description: 'Built Transport Management System backend, database schemas, and RBAC/PBAC security'
  },
  {
    year: '2025',
    title: 'Mobile ERP & Ride-Hailing Platforms',
    description: 'Mobile App Developer for RaAz Transport SC (Expo ERP) and Hidyat General Trading (Flutter)'
  },
  {
    year: '2026',
    title: 'Lead Mobile Developer at ChiNet & Graduation',
    description: 'Lead Mobile App Developer at ChiNet Link Tech (TMS & Shipment Marketplace with Flutter/GetX) and graduated with BSc IT from Mekelle University'
  }
]
